<template>
  <div class="default-group">
    <div class="card-curvey group-card">
      <!-- <v-icon class="copy-group-icon border-radius-standard" @click="copyGroupDialog = true">content_copy</v-icon> -->
      <v-dialog v-model="copyGroupDialog" width="400">
        <v-card class="border-radius-standard">
          <v-card-title>
            Copy Group
            <v-spacer />
            <v-icon @click="copyGroupDialog = false">close</v-icon>
          </v-card-title>
          <v-card-text>
            <label>Name</label>
            <v-text-field v-model="copyInput.name" outline />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="error" flat @click="copyGroupDialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" @click="copyGroup"> Copy </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-expansion-panel expand :value="0">
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-text-field
              style="width: 120px"
              class="solo-input handle min-width"
              v-model="group.title"
              @change="updateGroup"
              @click.native.stop="editTitle"
            ></v-text-field>
            <div class="">
              <v-btn
                @click="openCopyGroupDialog(index)"
                style="display: inline-block"
              >
                <v-icon color="#666">content_copy</v-icon>
              </v-btn>
              <v-btn
                class="handle"
                style="display: inline-block"
                x-small
                elevation-2
              >
                <span class="botter-move-icon" style="color: #666" />
              </v-btn>
              <v-btn
                v-if="group.blocks && !group.blocks.length"
                @click="openDeleteDialog(group)"
                color="error"
                style=""
              >
                <v-icon color="danger">delete_outline</v-icon>
              </v-btn>
            </div>
            <span v-if="blocksList" class="primary--text text-xs-right"
              ><span>{{ blocksList.length }}</span> Block<span
                v-if="blocksList.length > 1"
                >s</span
              ></span
            >
          </template>
          <draggable
            @change="draggedToGroup"
            class="layout row wrap"
            v-model="blocksList"
            group="people"
            @start="drag = true"
            @end="drag = false"
            handle=".blockHandeler"
          >
            <v-flex
              xs4
              v-for="(block, index) in blocksList"
              :key="index"
              class="blockHandeler"
            >
              <v-btn
                large
                round
                block
                :color="selectedBlock.id === block.id ? 'primary' : '#F1F1F1'"
                :class="[
                  'border-radius-standard',
                  selectedBlock.id === block.id ? 'white--text' : 'black--text',
                ]"
                @click="setSelectedBlock(block)"
              >
                {{ block.name }}
              </v-btn>
            </v-flex>
            <v-flex
              :xs4="blocksList && blocksList.length"
              :xs12="!blocksList || !blocksList.length"
            >
              <v-btn
                large
                round
                block
                @click="addNewBlock(group.id)"
                color="white"
                class="text-gray"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </draggable>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-dialog v-model="deleteGroupDialog" width="500">
        <delete-dialog
          :title="`group ${groupToDelete.title}`"
          @closeDialog="deleteGroupDialog = false"
          @onDelete="deleteGroup"
        ></delete-dialog>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import deleteDialog from "../../common/deleteDialog";
export default {
  name: "default-group",
  components: {
    draggable,
    deleteDialog,
  },
  props: {
    group: {
      type: Object,
      default: () => {
        return {};
      },
    },
    blocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    index: {
      Array,
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {
      blocksList: [],
      copyGroupDialog: false,
      copyInput: {
        name: "",
      },
      deleteGroupDialog: false,
      groupToDelete: "",
    };
  },
  mounted() {
    this.blocksList = this.blocks;
    this.$root.$on("copy-group", (payload) => {
      if (payload === this.index) {
        this.copyGroupDialog = true;
      }
    });
  },
  methods: {
    setSelectedBlock(block) {
      this.$store.dispatch("setSelectedBlock", block);
    },
    async addNewBlock(group_id) {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      const response = await this.$http.post("/blocks", {
        bot_id: this.botId,
        group_id: group_id,
        iGroup: -1,
        name: `Untitled Block ${this.blocks.length + 1}`,
        payload: [],
      });

      this.blocks.push(response.data);
      this.$store.dispatch("setSelectedBlock", response.data);
      this.$store.dispatch("setNewBlock", response.data);
      this.$store.dispatch("setSavingStatus", false);
      this.$store.dispatch("setLoader", false);
    },
    draggedToGroup(newItem) {
      if (newItem.added || newItem.moved) {
        this.updateBlockPosition(newItem.added || newItem.moved);
      }
    },
    async updateBlockPosition(newItem) {
      await this.$store.dispatch("setSavingStatus", true);
      await this.$store.dispatch("setLoader", true);
      let payload = await this.getBlockPayLoad(newItem.element.id);
      await this.$http.put(`/blocks/${newItem.element.id}`, {
        group_id: this.group.id,
        name: newItem.element.name,
        payload: payload.data.payload,
        order: newItem.newIndex,
      });

      this.$store.dispatch("setSavingStatus", false);
      this.$store.dispatch("setLoader", false);
    },
    async getBlockPayLoad(blockId) {
      let response = await this.$http_bot.get(`/blocks/${blockId}`);
      return response;
    },
    async copyBlock() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      const response = await this.$http.post("/blocks", {
        bot_id: this.botId,
        group_id: this.copiedBlock.group_id,
        iGroup: -1,
        name: `${this.copiedBlock.name} Copy`,
        payload: this.copiedBlock.payload,
      });

      this.blocks.push(response.data);
      this.$store.dispatch("setSelectedBlock", response.data);
      this.$store.dispatch("setNewBlock", response.data);
      this.$store.dispatch("setSavingStatus", false);
      this.$store.dispatch("setLoader", false);
    },
    editTitle() {},
    async updateGroup() {
      this.$store.dispatch("setLoader", true);
      this.$store.dispatch("setSavingStatus", true);
      await this.$http.put(`groups/${this.group.id}`, {
        order: this.index + 1,
        title: this.group.title,
      });

      this.$store.dispatch("setLoader", false);
      this.$store.dispatch("setSavingStatus", false);
    },
    async copyGroup() {
      this.$store.dispatch("setLoader", true);
      await this.$http.post(`/groups/${this.botId}/duplicate`, {
        group_id: this.group.id,
        name: this.copyInput.name,
      });

      this.$store.dispatch("setLoader", false);
      this.copyGroupDialog = false;
      this.$store.dispatch("setSnackbar", {
        text: `Copied Successfully`,
        color: "success",
        status: true,
      });
      this.$emit("copy");
    },
    openCopyGroupDialog(payload) {
      if (payload === this.index) {
        this.copyGroupDialog = true;
      }
    },
    openDeleteDialog(group) {
      this.deleteGroupDialog = true;
      this.groupToDelete = group;
    },
    async deleteGroup() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      await this.$http.delete(`/groups/${this.groupToDelete.id}`);

      this.$root.$emit("delete-group", this.groupToDelete);
      this.groupToDelete = {};
    },
  },
  computed: {
    selectedBlock() {
      return this.$store.state.blocksBuild.selectedBlock;
    },
    copiedBlock() {
      return this.$store.state.blocksBuild.copiedBlock;
    },
    botId() {
      return this.$store.state.bot.botId;
    },
    updatedBlockName() {
      return this.$store.state.blocksBuild.updatedBlockName.name;
    },
  },
  watch: {
    group(newVal, oldVal) {
      this.updateGroup();
    },
    blocks() {
      this.blocksList = this.blocks;
    },
    copiedBlock(state) {
      if (state.id && state.group_id === this.group.id) {
        this.copyBlock();
      }
    },
    updatedBlockName(state) {
      const block = this.$store.state.blocksBuild.updatedBlockName;
      if (state) {
        let index = _.findIndex(this.blocks, (o) => {
          return o.id === block.id;
        });
        if (index !== -1) {
          this.blocks[index].name = block.name;
        }
      }
    },
  },
};
</script>

<style scoped>
.copy-group-icon {
  position: absolute;
  font-size: 18px;
  margin-top: -10px;
  margin-left: -10px;
  background-color: #ffffff;
  z-index: 2;
  padding: 5px;
  cursor: pointer;
}
</style>
